"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useActiveClassName = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useActiveClassName = function useActiveClassName(input) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isActive = _useState2[0],
      setIsActive = _useState2[1];

  var updateIsActiveState = function updateIsActiveState(text) {
    if (text !== '') {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  };

  var activeClassName = function activeClassName(element) {
    return isActive ? "active-".concat(element) : '';
  };

  (0, _react.useEffect)(function () {
    updateIsActiveState(input.value);
  });
  return {
    activeClassName: activeClassName,
    isActive: isActive
  };
};

exports.useActiveClassName = useActiveClassName;